import React, { useEffect, useState, useRef } from "react";
import "../comparison/table.css";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import _ from "lodash";
import { requestPublic } from "../../helpers/createRequest";
import queryString from "query-string";
import Loader from "../../components/loader/Loader";
import { withRouter } from "react-router-dom";
import "./export.css";
import ReactToPrint from "react-to-print";
import moment from "moment";
import PrintableComponentNewUz from "./FssUz";
import { useDispatch } from "react-redux";
import i18next from "i18next";
import { language } from "../../redux/actions/langAction";
import redirectUrl from "../../utils/navigate";

const tableTwo = {
  width: "50%",
};

const ExportFss = (props) => {
  const [certificate, setCertificate] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [countries, setCountries] = useState([]);
  const [certLang, setCertLang] = useState("en");

  const queryParams = queryString.parse(window.location.search);
  const number = queryParams.number;
  const componentRef = useRef();

  const dispatch = useDispatch();
  const changeLan = (lang) => {
    if (lang == "uz" || lang == "ru") {
      i18next.changeLanguage(lang);
      dispatch(language(lang));
    }
    setCertLang(lang);
  };

  const getCountries = async () => {
    const countryList = await requestPublic
      .get(`api/countries`)
      .then((res) => res.data)
      .catch((err) => {
        console.log(err);
      });
    setCountries(countryList);
  };

  useEffect(() => {
    if (number) {
      fetchData();
    } else {
      setIsLoading(false);
      toast.error("Xatolik!");
    }
    getCountries();
  }, []);

  const fetchData = async () => {
    await requestPublic
      .get(`api/import-fss/detail/?number=${number}`)
      .then((res) => {
        if (res.data) {
          setCertificate(res.data);
          setIsLoading(false);
        } else {
          setIsLoading(false);
          toast.warning("Natija topilmadi!");
        }
      })
      .catch((e) => {
        setIsLoading(false);
        if (e.response.status == 451) {
          toast.error("Ushbu oferta raqamiga joriy xizmat ko'rsatilmaydi!");
        } else {
          toast.error("Xatolik!");
        }
      });
  };

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        certificate && (
          <div className="row">
            <div className="cert-container">
              {/* <div className="note">
              <AiOutlineExclamationCircle className="icon" />
              <p>{t("navbar.test1")}</p>
            </div> */}
              <div className="card-wrapper">
                <div className="card card-body">
                  <div
                    className="langs"
                    style={{ justifyContent: "flex-start" }}
                  >
                    <div
                      className={certLang === "en" ? "active-lan" : ""}
                      onClick={() => changeLan("en")}
                    >
                      EN
                    </div>
                    <div
                      className={certLang === "uz" ? "active-lan" : ""}
                      onClick={() => changeLan("uz")}
                    >
                      UZ
                    </div>
                    <div
                      className={certLang === "ru" ? "active-lan" : ""}
                      onClick={() => changeLan("ru")}
                    >
                      RU
                    </div>
                  </div>
                  <div className="down-btn1">
                    <ReactToPrint
                      trigger={() => (
                        <button className="btn-icon">Chop etish</button>
                      )}
                      content={() => componentRef.current}
                      pageStyle="@page { margin: 20px !important;}"
                    />
                    {/* <span className="tooltip">{t("invoice.print")}</span> */}
                  </div>

                  {certLang == "en" ? (
                    <PrintableComponentNew
                      ref={componentRef}
                      data={certificate}
                      countries={countries}
                    />
                  ) : (
                    <PrintableComponentNewUz
                      ref={componentRef}
                      data={certificate}
                      countries={countries}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        )
      )}
    </>
  );
};

const PrintableComponentNew = React.forwardRef((props, ref) => {
  const { data, countries } = props;
  let toCountry;
  let fromCountry;

  if (data) {
    toCountry = countries.filter((c) => c.id == data.importer_country)[0]
      ?.name_en;

    fromCountry = countries.filter((c) => c.id == data.exporter_country)[0]
      ?.name_en;
  }

  const regExp = new RegExp("23\\d{9}");
  let importNum = data.extra_info?.match(regExp);
  const regExpNum = new RegExp("2315\\d{7}");
  const spsNote = data?.api_data?.SPSExchangedDocument?.IncludedSPSNote;
  let spsImpNum;
  let spsFinContent = "";

  if (spsNote) {
    if (_.isArray(spsNote)) {
      spsNote?.map((item, idx) => {
        if (typeof item.Content != "string") {
          spsImpNum = item.Content["#text"]?.match(regExpNum);
        }
        if (item.Content == "5") {
          spsFinContent = `No financial liability with respect to this certificate shall attach to ${
            data?.api_data?.SPSExchangedDocument?.IssuerSPSParty.Name
              ? data?.api_data?.SPSExchangedDocument?.IssuerSPSParty.Name
              : "Issuing NPPO"
          } or to any of its officers or representatives.`;
        }
      });
    } else {
      if (spsNote.Content == "5") {
        spsFinContent = `No financial liability with respect to this certificate shall attach to ${
          data?.api_data?.SPSExchangedDocument?.IssuerSPSParty.Name
            ? data?.api_data?.SPSExchangedDocument?.IssuerSPSParty.Name
            : "Issuing NPPO"
        } or to any of its officers or representatives.`;
      }
    }
  }

  const itemIsArray = _.isArray(
    data?.api_data?.SPSConsignment?.IncludedSPSConsignmentItem
      ?.IncludedSPSTradeLineItem
  );
  const itemParentIsArray = _.isArray(
    data?.api_data?.SPSConsignment?.IncludedSPSConsignmentItem
  );

  let productType = "";
  let condition = "";

  if (!spsImpNum || (!productType && !condition)) {
    if (itemParentIsArray) {
      data?.api_data?.SPSConsignment?.IncludedSPSConsignmentItem?.map(
        (par, idx) => {
          if (
            _.isArray(
              par.IncludedSPSTradeLineItem?.AdditionalInformationSPSNote
            )
          ) {
            par.IncludedSPSTradeLineItem?.AdditionalInformationSPSNote?.map(
              (cont, id) => {
                if (cont.Subject == "ADIPTLIL") {
                  if (typeof cont.Content != "object") {
                    spsImpNum = cont.Content;
                    return;
                  }
                }
              }
            );
          }
          if (par.IncludedSPSTradeLineItem?.ApplicableSPSClassification) {
            if (
              _.isArray(
                par.IncludedSPSTradeLineItem?.ApplicableSPSClassification
              )
            ) {
              par.IncludedSPSTradeLineItem?.ApplicableSPSClassification?.map(
                (clas, idx) => {
                  if (clas.SystemName == "IPPCPCVP") {
                    if (typeof clas.ClassName == "object") {
                      productType = clas.ClassName["#text"];
                    } else {
                      productType = clas.ClassName;
                    }
                  } else if (clas.SystemName == "IPPCPCC") {
                    if (typeof clas.ClassName == "object") {
                      condition = clas.ClassName["#text"];
                    } else {
                      condition = clas.ClassName;
                    }
                  }
                }
              );
            } else if (
              typeof par.IncludedSPSTradeLineItem
                ?.ApplicableSPSClassification == "object"
            ) {
              const clas =
                par.IncludedSPSTradeLineItem?.ApplicableSPSClassification;
              if (clas.SystemName == "IPPCPCVP") {
                if (typeof clas.ClassName == "object") {
                  productType = clas.ClassName["#text"];
                } else {
                  productType = clas.ClassName;
                }
              } else if (clas.SystemName == "IPPCPCC") {
                if (typeof clas.ClassName == "object") {
                  condition = clas.ClassName["#text"];
                } else {
                  condition = clas.ClassName;
                }
              }
            }
          }
        }
      );
    } else {
      if (!itemIsArray) {
        if (
          _.isArray(
            data?.api_data?.SPSConsignment?.IncludedSPSConsignmentItem
              ?.IncludedSPSTradeLineItem?.AdditionalInformationSPSNote
          )
        ) {
          data?.api_data?.SPSConsignment?.IncludedSPSConsignmentItem?.IncludedSPSTradeLineItem?.AdditionalInformationSPSNote?.map(
            (content, idx) => {
              if (content.Subject == "ADIPTLIL") {
                if (typeof content.Content != "object") {
                  spsImpNum = content.Content;
                  return;
                }
              }
            }
          );
        }

        if (
          _.isArray(
            data?.api_data?.SPSConsignment?.IncludedSPSConsignmentItem
              ?.IncludedSPSTradeLineItem?.ApplicableSPSClassification
          )
        ) {
          data?.api_data?.SPSConsignment?.IncludedSPSConsignmentItem?.IncludedSPSTradeLineItem?.ApplicableSPSClassification?.map(
            (clas, idx) => {
              if (clas.SystemName == "IPPCPCVP") {
                if (typeof clas.ClassName == "object") {
                  productType = clas.ClassName["#text"];
                } else {
                  productType = clas.ClassName;
                }
              } else if (clas.SystemName == "IPPCPCC") {
                if (typeof clas.ClassName == "object") {
                  condition = clas.ClassName["#text"];
                } else {
                  condition = clas.ClassName;
                }
              }
            }
          );
        } else if (
          typeof data?.api_data?.SPSConsignment?.IncludedSPSConsignmentItem
            ?.IncludedSPSTradeLineItem?.ApplicableSPSClassification == "object"
        ) {
          const clas =
            data?.api_data?.SPSConsignment?.IncludedSPSConsignmentItem
              ?.IncludedSPSTradeLineItem?.ApplicableSPSClassification;
          if (clas.SystemName == "IPPCPCVP") {
            if (typeof clas.ClassName == "object") {
              productType = clas.ClassName["#text"];
            } else {
              productType = clas.ClassName;
            }
          } else if (clas.SystemName == "IPPCPCC") {
            if (typeof clas.ClassName == "object") {
              condition = clas.ClassName["#text"];
            } else {
              condition = clas.ClassName;
            }
          }
        }
      } else {
        data?.api_data?.SPSConsignment?.IncludedSPSConsignmentItem?.IncludedSPSTradeLineItem?.map(
          (item, id) => {
            if (_.isArray(item.AdditionalInformationSPSNote)) {
              item.AdditionalInformationSPSNote?.map((cont, idx) => {
                if (cont.Subject == "ADIPTLIL") {
                  if (typeof cont.Content != "object") {
                    spsImpNum = cont.Content;
                    return;
                  }
                }
              });
            }
            if (_.isArray(item.ApplicableSPSClassification)) {
              item.ApplicableSPSClassification?.map((clas, idx) => {
                if (clas.SystemName == "IPPCPCVP") {
                  if (typeof clas.ClassName == "object") {
                    productType = clas.ClassName["#text"];
                  } else {
                    productType = clas.ClassName;
                  }
                } else if (clas.SystemName == "IPPCPCC") {
                  if (typeof clas.ClassName == "object") {
                    condition = clas.ClassName["#text"];
                  } else {
                    condition = clas.ClassName;
                  }
                }
              });
            } else if (typeof item.ApplicableSPSClassification == "object") {
              if (item.ApplicableSPSClassification.SystemName == "IPPCPCVP") {
                if (
                  typeof item.ApplicableSPSClassification.ClassName == "object"
                ) {
                  productType =
                    item.ApplicableSPSClassification.ClassName["#text"];
                } else {
                  productType = item.ApplicableSPSClassification.ClassName;
                }
              } else if (
                item.ApplicableSPSClassification.SystemName == "IPPCPCC"
              ) {
                if (
                  typeof item.ApplicableSPSClassification.ClassName == "object"
                ) {
                  condition =
                    item.ApplicableSPSClassification.ClassName["#text"];
                } else {
                  condition = item.ApplicableSPSClassification.ClassName;
                }
              }
            }
          }
        );
      }
    }
  }

  let spsClause = "";

  let additionalContent =
    data?.api_data?.SPSExchangedDocument?.SignatorySPSAuthentication
      ?.IncludedSPSClause;
  if (additionalContent) {
    if (_.isArray(additionalContent)) {
      additionalContent?.map((content, idx) => {
        if (content.ID == 1) {
          spsClause +=
            "This is to certify that the plants, plant product or other regulated articles described herein have been inspected and/or tested according to appropriate official procedures and are considered to be free from the quarantine pests, specified by the importing contracting party and to conform with the current phytosanitary requirements of the importing contracting party including those for regulated non- quarantine pests.";
          spsClause += " ";
        } else if (content.ID == 2) {
          spsClause +=
            "They are deemed to be practically free from other pests. ";
        }
      });
    } else {
      if (additionalContent.ID == 1) {
        spsClause +=
          "This is to certify that the plants, plant product or other regulated articles described herein have been inspected and/or tested according to appropriate official procedures and are considered to be free from the quarantine pests, specified by the importing contracting party and to conform with the current phytosanitary requirements of the importing contracting party including those for regulated non- quarantine pests.";
      }
    }
  }

  let treatment = "";
  if (!_.isEmpty(data?.products[0]?.treatments)) {
    if (data?.products[0]?.treatments[0]?.full_treatment) {
      if (data?.products[0]?.treatments[0]?.full_treatment != "NULL") {
        if (data?.products[0]?.treatments[0]?.full_treatment.includes("{")) {
          let treat = JSON.parse(
            data?.products[0]?.treatments[0]?.full_treatment
              .replaceAll(`"{`, `'{`)
              .replaceAll(`}"`, `}'`)
              .replaceAll("'", `"`)
          );
          treatment = treat["#text"];
        } else {
          treatment = data?.products[0]?.treatments[0]?.full_treatment;
        }
      }

      // console.log(treat["#text"]);
    }
  }

  let reexport = "";

  if (data?.certificate_type == 657) {
    if (!_.isEmpty(data?.products[0]?.sps_notes)) {
      data?.products[0]?.sps_notes?.map((sps, idx) => {
        if (sps.note_type == 8) {
          reexport = sps.text;
        }
      });
    }
  }

  let distMarks = "";

  if (!_.isEmpty(data?.sps_notes)) {
    data?.sps_notes?.map((sps, idx) => {
      if (sps.note_type == 7) {
        distMarks = sps.text;
      }
    });
  }

  let adrpn = "";
  let adrpnContent;

  if (!adrpn) {
    if (_.isArray(data?.api_data?.SPSExchangedDocument?.IncludedSPSNote)) {
      adrpnContent = data?.api_data?.SPSExchangedDocument?.IncludedSPSNote?.map(
        (nt, idx) => {
          if (nt.Subject == "ADRPN") {
            if (typeof nt.Content != "object") {
              adrpn = nt.Content;
              return (
                <span>
                  Link:{" "}
                  <a
                    href={`${redirectUrl}efito/import-fss/print?number=${nt.Content}`}
                    target="_blank"
                  >
                    {adrpn}
                  </a>
                </span>
              );
            } else {
              adrpn = nt.Content["#text"];
              return (
                <span>
                  Link:{" "}
                  <a
                    href={`${redirectUrl}efito/import-fss/print?number=${nt.Content["#text"]}`}
                    target="_blank"
                  >
                    {adrpn}
                  </a>
                </span>
              );
            }
          }
        }
      );
    }
  }

  let slicedAdrpn = "";

  if (!adrpn) {
    adrpnContent = data?.sps_notes?.map((nt, idx) => {
      if (nt.note_type == 1) {
        if (nt.text.includes("cancels")) {
          // console.log(nt.text);
          let arr = nt.text.split("cancels");
          slicedAdrpn = arr[1].slice(1, arr[1].indexOf(","));
          return (
            <span>
              Link:{" "}
              <a
                href={`${redirectUrl}efito/import-fss/print?number=${slicedAdrpn}`}
                target="_blank"
              >
                {slicedAdrpn}
              </a>
            </span>
          );
        }
      }
    });
  }

  let replacedCertContent = "";

  if (!replacedCertContent) {
    data?.sps_notes?.map((nt, idx) => {
      if (nt.note_type == 1) {
        if (nt.text.includes("cancels")) {
          replacedCertContent = nt.text;
        }
      }
    });
  }

  if (!replacedCertContent) {
    const filtered = data?.sps_notes?.filter((nt) => nt.note_type == 6);
    replacedCertContent = filtered?.sort((a, b) => b.id - a.id)[0]?.text || "";
  }

  let description = "";

  if (data?.api_data?.SPSExchangedDocument?.Description) {
    if (typeof data?.api_data?.SPSExchangedDocument?.Description != "object") {
      description = data.api_data.SPSExchangedDocument.Description;
    } else {
      description = data.api_data.SPSExchangedDocument.Description["#text"];
    }
  }

  const adtlil = [];

  if (itemParentIsArray) {
    data?.api_data?.SPSConsignment?.IncludedSPSConsignmentItem?.map(
      (item, idx) => {
        if (item?.IncludedSPSTradeLineItem) {
          if (item?.IncludedSPSTradeLineItem?.AdditionalInformationSPSNote) {
            if (
              _.isArray(
                item?.IncludedSPSTradeLineItem?.AdditionalInformationSPSNote
              )
            ) {
              let count = 0;
              item?.IncludedSPSTradeLineItem?.AdditionalInformationSPSNote.map(
                (sps, sqe) => {
                  if (sps.Subject == "ADTLIL") {
                    if (typeof sps.Content == "object") {
                      // adtlil.push(
                      //   `${
                      //     count == 0 ? "Commodity № " + (idx + 1) + ": " : " "
                      //   } ${sps.Content["#text"]}`
                      // );
                      // count++;
                      if (count == 0) {
                        adtlil.push(
                          `Commodity № ${idx + 1}: ${sps.Content["#text"]}`
                        );
                        count++;
                      } else {
                        adtlil[adtlil.length - 1] =
                          adtlil[adtlil.length - 1] +
                          ` ${sps.Content["#text"]}`;
                      }
                    }
                  }
                }
              );
            }
          }
        }
      }
    );
  }

  let noteTypeDate = "";
  if (!noteTypeDate) {
    data?.sps_notes?.map((note, idx) => {
      if (note.note_type == 3) {
        noteTypeDate = note.text;
        return noteTypeDate;
      }
    });
  }

  const displayCountries = (transits) => {
    const cties = [];
    if (transits) {
      for (let i = 0; i < transits.length; i++) {
        cties.push(countries.filter((ct) => ct.id == transits[i].country)[0]);
      }
    }
    // console.log();
    return cties.filter(Boolean);
  };

  if (!data) {
    return null;
  }
  return (
    <>
      {data?.exporter_country == 192 ? (
        <div
          className="printable-spot"
          style={{
            minHeight: "1011px",
            width: "100%",
            padding: "20px 25px",
            // height: "calc(100% - 30px)",
            // backgroundImage: 'url("./assets/images/fss.svg") !important',
            backgroundImage: `${
              data?.status == 40
                ? 'url("./assets/images/replaced.svg") !important'
                : 'url("./assets/images/fss.svg") !important'
            } `,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center 300px",
            position: "relative",
          }}
          ref={ref}
        >
          <div
            className="cert-top"
            style={{
              display: "flex",
              justifyContent: "space-between",
              flexDirection: "row",
            }}
          >
            <span>
              <strong>{data?.number}</strong>
            </span>
            <span>
              <strong>Phytosanitary Certificate</strong>
            </span>
          </div>

          <div style={{ height: "100%" }}>
            <div className="invoice-info">
              <table
                className="table-two"
                style={{ width: "100%", marginBottom: 0 }}
              >
                <tbody>
                  <tr>
                    <th
                      rowSpan={14}
                      style={{
                        padding: "3px",
                      }}
                    >
                      <span
                        style={{
                          width: "16px",
                          // borderBottom: "none",
                          // borderTop: "none",
                          // writingMode: "tb-rl",
                          writingMode: "vertical-rl",
                          // textOrientation: "mixed",
                          transform: "rotate(-180deg)",
                          textAlign: "center",
                          fontWeight: 600,
                          fontSize: "16px",
                          whiteSpace: "nowrap",
                          // padding: "5px",
                        }}
                      >
                        Phytosanitary Certificate
                      </span>
                    </th>
                    <th
                      style={{
                        width: "48%",
                        borderBottom: "none",
                        // borderTop: "none",
                      }}
                    >
                      FROM: Plant Protection Organization of
                    </th>
                    <th
                      style={{
                        width: "48%",
                        borderBottom: "none",
                        // borderTop: "none",
                      }}
                    >
                      TO: Plant Protection Organization of
                    </th>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "center", borderTop: "none" }}>
                      {fromCountry}
                    </td>
                    <td style={{ textAlign: "center", borderTop: "none" }}>
                      {toCountry}
                    </td>
                  </tr>
                  <tr>
                    <th
                      colSpan={2}
                      style={{ textAlign: "center", background: "#c4c7c7" }}
                      className="th-heading"
                    >
                      I. DESCRIPTION OF CONSIGNMENT
                    </th>
                  </tr>
                  <tr>
                    <th style={tableTwo}>Name and Address of Exporter</th>
                    <th style={tableTwo}>
                      Declared Name and Address of Consignee
                    </th>
                  </tr>
                  <tr>
                    <td style={tableTwo}>
                      {data.exporter_name}
                      <br />
                      {data.exporter_address}
                    </td>
                    <td style={tableTwo}>
                      {data.importer_name}
                      <br />
                      {data.importer_address}
                    </td>
                  </tr>
                  <tr>
                    <th style={tableTwo}>Declared Means of Conveyance</th>
                    <th style={tableTwo}>Declared Point of Entry</th>
                  </tr>
                  <tr>
                    <td style={tableTwo}>
                      {data.transport_method}{" "}
                      {data.transport_number
                        ? `(${data.transport_number})`
                        : ""}
                    </td>
                    <td style={tableTwo}>{toCountry}</td>
                  </tr>
                  <tr>
                    <th style={tableTwo}>Seals and container numbers</th>
                    <th style={tableTwo}>Distinguishing Marks</th>
                  </tr>
                  <tr>
                    <th
                      colSpan={2}
                      style={{ textAlign: "center", background: "#c4c7c7" }}
                      className="th-heading"
                    >
                      II. Commodities
                    </th>
                  </tr>
                  <tr>
                    <td colSpan={2}>
                      {data?.products?.map((pro, idx) => (
                        <table
                          key={idx}
                          style={{ marginBottom: "2px", width: "100%" }}
                          className="product-table"
                        >
                          <thead>
                            <tr>
                              <th
                                style={{ width: "12px", background: "#c4c7c7" }}
                                className="th-heading"
                              >
                                {idx + 1}
                              </th>
                              <th>Description</th>
                              <th>Scientific names</th>
                              <th>Measures</th>
                              <th>Number and Description of Packages</th>
                              <th>Distinguishing marks</th>
                              <th>Place of Origin</th>
                              <th>Import Permit Number</th>
                              <th>Date of Inspection</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td colSpan={2}>
                                {pro.name + " " + pro.hs_code}
                              </td>
                              <td>{pro.botanic_name}</td>
                              <td>
                                {pro.net_quantity
                                  ? pro.net_quantity.replace(/\.000$/, "")
                                  : ""}{" "}
                                {pro.net_quantity_unit}
                              </td>
                              <td>
                                {pro.package_quantity
                                  ? pro.package_quantity.replace(/\.000$/, "") +
                                    " " +
                                    pro.package_quantity_unit
                                  : ""}
                                {}
                              </td>
                              <td>{}</td>
                              <td>
                                {
                                  countries?.filter(
                                    (c) => c.id == pro.manufactured_country
                                  )[0]?.name_en
                                }
                              </td>
                              <td>
                                {importNum ? (
                                  <a
                                    href={`https://efito.uz/ikr/${importNum}/download`}
                                    target="_blank"
                                  >
                                    {importNum}
                                  </a>
                                ) : (
                                  ""
                                )}
                              </td>
                              <td>
                                {moment(data.given_date).format("DD-MM-YYYY")}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      ))}
                    </td>
                  </tr>
                  <tr>
                    <th colSpan={2}>Additional Declarations</th>
                  </tr>
                  <tr>
                    <td colSpan={2}>{data.extra_info}</td>
                  </tr>
                  <tr>
                    <th colSpan={2}>
                      Disinfestation and/or Disinfection Treatment
                    </th>
                  </tr>
                  <tr>
                    <th
                      colSpan={2}
                      style={{ textAlign: "center", background: "#c4c7c7" }}
                      className="th-heading"
                    >
                      III. Certification
                    </th>
                  </tr>
                </tbody>
              </table>
              <table style={{ width: "auto", marginLeft: "23px" }}>
                <tbody>
                  <tr>
                    <td colSpan={2} style={{ borderTop: "none" }}>
                      This is to certify that the plants, plant product or other
                      regulated articles described herein have been inspected
                      and/or tested according to appropriate official procedures
                      and are considered to be free from the quarantine pests,
                      specified by the importing contracting party and to
                      conform with the current phytosanitary requirements of the
                      importing contracting party including those for regulated
                      non- quarantine pests.
                    </td>
                  </tr>

                  <tr>
                    <td style={tableTwo}>
                      <strong>Place of issue:</strong> {fromCountry}
                    </td>
                    <td style={tableTwo}>
                      <strong>Name of authorized officer: </strong>
                      {data.inspector_name || ""}
                    </td>
                  </tr>
                  <tr>
                    <td style={tableTwo}>
                      <strong>Date:</strong>{" "}
                      {moment(data.given_date).format("DD-MM-YYYY")}
                    </td>
                    <td style={tableTwo}>
                      <strong>Signature:</strong>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      ) : (
        <div
          className={`${
            data?.status == 70 ? "printable-spot" : "printable-spot replaced"
          }`}
          style={{
            minHeight: "1011px",
            width: "100%",
            padding: "20px 25px",
            // height: "calc(100% - 30px)",
            // backgroundImage: 'url("./assets/images/fss.svg") !important',
            // backgroundImage: `${data?.status == 40 ? 'url("./assets/images/replaced.svg") !important' : 'url("./assets/images/fss.svg") !important'} `,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center 300px",
            position: "relative",
          }}
          ref={ref}
        >
          <div
            className="cert-top"
            style={{
              display: "flex",
              justifyContent: "space-between",
              flexDirection: "row",
            }}
          >
            <span>
              <strong>{data?.number}</strong>
            </span>
            <span>
              <strong>
                {data?.certificate_type == 851
                  ? "Phytosanitary Certificate"
                  : data?.certificate_type == 657
                  ? "Phytosanitary Certificate for Reexport"
                  : data?.certificate_type == 312
                  ? "Acknowledgement message"
                  : "Phytosanitary Certificate"}
              </strong>
            </span>
          </div>

          <div style={{ height: "100%" }}>
            <div className="invoice-info">
              <table
                className="table-two"
                style={{ width: "100%", marginBottom: 0 }}
              >
                <tbody>
                  <tr>
                    <th
                      rowSpan={16}
                      style={{
                        padding: "3px",
                        // width: '20px'
                      }}
                    >
                      <span
                        style={{
                          width: "16px",
                          // borderBottom: "none",
                          // borderTop: "none",
                          // writingMode: "tb-rl",
                          writingMode: "vertical-rl",
                          // textOrientation: "mixed",
                          transform: "rotate(-180deg)",
                          textAlign: "center",
                          fontWeight: 600,
                          fontSize: "16px",
                          whiteSpace: "nowrap",
                          // padding: "5px",
                        }}
                      >
                        {data?.certificate_type == 851
                          ? "Phytosanitary Certificate"
                          : data?.certificate_type == 657
                          ? "Phytosanitary Certificate for Reexport"
                          : data?.certificate_type == 312
                          ? "Acknowledgement message"
                          : "Phytosanitary Certificate"}
                      </span>
                    </th>
                    <th
                      style={{
                        width: "50%",
                        borderBottom: "none",
                        // borderTop: "none",
                      }}
                    >
                      FROM: Plant Protection Organization of
                    </th>
                    <th
                      style={{
                        width: "50%",
                        borderBottom: "none",
                        // borderTop: "none",
                      }}
                    >
                      TO: Plant Protection Organization of
                    </th>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "center", borderTop: "none" }}>
                      {fromCountry}
                      {data?.api_data?.SPSExchangedDocument?.IssuerSPSParty.Name
                        ? ` (${data?.api_data?.SPSExchangedDocument?.IssuerSPSParty.Name})`
                        : ""}
                    </td>
                    <td style={{ textAlign: "center", borderTop: "none" }}>
                      {toCountry}
                    </td>
                  </tr>
                  <tr>
                    <th
                      colSpan={2}
                      style={{ textAlign: "center", background: "#c4c7c7" }}
                      className="th-heading"
                    >
                      I. DESCRIPTION OF CONSIGNMENT
                    </th>
                  </tr>
                  <tr>
                    <th style={tableTwo}>Name and Address of Exporter</th>
                    <th style={tableTwo}>
                      Declared Name and Address of Consignee
                    </th>
                  </tr>
                  <tr>
                    <td style={tableTwo}>
                      {data.exporter_name}
                      <br />
                      {data.exporter_address}
                    </td>
                    <td style={tableTwo}>
                      {data.importer_name}
                      <br />
                      {data.importer_address}
                    </td>
                  </tr>
                  <tr>
                    <th style={tableTwo}>Declared Means of Conveyance</th>
                    <th style={tableTwo}>Declared Point of Entry</th>
                  </tr>
                  <tr>
                    <td style={tableTwo}>
                      {data.transports ? data.transports[0]?.method : ""}
                      {data?.api_data?.SPSConsignment
                        ?.LoadingBaseportSPSLocation?.Name
                        ? ` (${data?.api_data?.SPSConsignment?.LoadingBaseportSPSLocation?.Name})`
                        : ""}
                    </td>
                    <td style={tableTwo}>
                      {data.entry_point || ""}
                      {!_.isEmpty(countries) &&
                      !_.isEmpty(data?.transit_countries)
                        ? ", Transit: " +
                          displayCountries(data?.transit_countries)
                            ?.map((country) => country?.name_en || "")
                            .join(", ")
                        : ""}
                    </td>
                  </tr>
                  <tr>
                    <th style={tableTwo}>Seals and container numbers</th>
                    <th style={tableTwo}>Distinguishing Marks</th>
                  </tr>
                  <tr>
                    <td></td>
                    <td>{distMarks ? distMarks : ""}</td>
                  </tr>
                  <tr>
                    <th
                      colSpan={2}
                      style={{ textAlign: "center", background: "#c4c7c7" }}
                      className="th-heading"
                    >
                      II. Commodities
                    </th>
                  </tr>
                  <tr>
                    <td colSpan={2}>
                      {data?.products?.map((pro, idx) => (
                        <table
                          key={idx}
                          style={{ marginBottom: "2px", width: "100%" }}
                          className="product-table"
                        >
                          <thead>
                            <tr>
                              <th
                                style={{ width: "12px", background: "#c4c7c7" }}
                                className="th-heading"
                              >
                                {idx + 1}
                              </th>
                              <th>Description</th>
                              <th>Scientific names</th>
                              <th>Measures</th>
                              <th>Number and Description of Packages</th>
                              <th>Distinguishing marks</th>
                              <th>Place of Origin</th>
                              <th>Import Permit Number</th>
                              <th>Date of Inspection</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td
                                colSpan={2}
                                style={{ whiteSpace: "break-spaces" }}
                              >
                                {pro.name + " " + pro.hs_code}
                                <br />
                                {productType
                                  ? data?.exporter_country != 106
                                    ? `Type: ${productType}` + "\n"
                                    : `Intended use: ${productType}` + "\n"
                                  : ""}
                                {condition ? `Condition: ${condition}\n` : ""}
                                {!itemIsArray
                                  ? data?.api_data?.SPSConsignment
                                      ?.IncludedSPSConsignmentItem
                                      ?.IncludedSPSTradeLineItem?.IntendedUse
                                    ? data?.exporter_country != 106
                                      ? "Intended use: " +
                                        data?.api_data?.SPSConsignment
                                          ?.IncludedSPSConsignmentItem
                                          ?.IncludedSPSTradeLineItem
                                          ?.IntendedUse["#text"]
                                      : `Type: ` +
                                        data?.api_data?.SPSConsignment
                                          ?.IncludedSPSConsignmentItem
                                          ?.IncludedSPSTradeLineItem
                                          ?.IntendedUse["#text"]
                                    : ""
                                  : data?.api_data?.SPSConsignment
                                      ?.IncludedSPSConsignmentItem
                                      ?.IncludedSPSTradeLineItem[0]?.IntendedUse
                                  ? data?.exporter_country != 106
                                    ? "Intended use: " +
                                      data?.api_data?.SPSConsignment
                                        ?.IncludedSPSConsignmentItem
                                        ?.IncludedSPSTradeLineItem[0]
                                        ?.IntendedUse["#text"]
                                    : `Type: ` +
                                      data?.api_data?.SPSConsignment
                                        ?.IncludedSPSConsignmentItem
                                        ?.IncludedSPSTradeLineItem[0]
                                        ?.IntendedUse["#text"]
                                  : ""}
                                {itemParentIsArray
                                  ? data?.api_data?.SPSConsignment
                                      ?.IncludedSPSConsignmentItem[idx]
                                      ?.IncludedSPSTradeLineItem?.IntendedUse
                                    ? "Intended use: " +
                                      data?.api_data?.SPSConsignment
                                        ?.IncludedSPSConsignmentItem[idx]
                                        ?.IncludedSPSTradeLineItem?.IntendedUse[
                                        "#text"
                                      ]
                                    : ""
                                  : ""}
                              </td>
                              <td>{pro.botanic_name}</td>
                              <td style={{ whiteSpace: "pre-line" }}>
                                {/* {pro.net_quantity} {pro.net_quantity_unit} */}
                                {pro.gross_quantity
                                  ? pro.net_quantity == pro.gross_quantity
                                    ? pro.net_quantity.replace(/\.000$/, "") +
                                      " " +
                                      pro.net_quantity_unit
                                    : "Net weight: " +
                                      pro.net_quantity.replace(/\.000$/, "") +
                                      " " +
                                      pro.net_quantity_unit +
                                      `\n` +
                                      "Gross weight: " +
                                      pro.gross_quantity.replace(/\.000$/, "") +
                                      " " +
                                      pro.gross_quantity_unit
                                  : pro.net_quantity
                                  ? pro.net_quantity.replace(/\.000$/, "") +
                                    " " +
                                    pro.net_quantity_unit
                                  : //shu qism qoshildi

                                  pro.other_measure?.value
                                  ? parseFloat(
                                      pro.other_measure.value.toString()
                                    ).toString() +
                                    " " +
                                    pro.other_measure.unit
                                  : //shu qism qoshildi end
                                    ""}

                                {pro.net_weight?.value
                                  ? pro.gross_weight?.value
                                    ? pro.net_weight?.value ==
                                      pro.gross_weight?.value
                                      ? pro.net_weight?.value?.replace(
                                          /\.000$/,
                                          ""
                                        ) +
                                        " " +
                                        pro.net_weight?.unit
                                      : "Net weight: " +
                                        pro.net_weight?.value.replace(
                                          /\.000$/,
                                          ""
                                        ) +
                                        " " +
                                        pro.net_weight?.unit +
                                        `\n` +
                                        "Gross weight: " +
                                        pro.gross_weight?.value.replace(
                                          /\.000$/,
                                          ""
                                        ) +
                                        " " +
                                        pro.gross_weight?.unit
                                    : pro.net_weight?.value?.replace(
                                        /\.000$/,
                                        ""
                                      ) +
                                      " " +
                                      pro.net_weight?.unit
                                  : ""}
                              </td>
                              <td>
                                {/* {pro.package_quantity
                                  ? pro.package_quantity +
                                    ", " +
                                    pro.package_quantity_unit
                                  : ""} */}
                                {/* {data?.api_data?.SPSConsignment
                                  ?.IncludedSPSConsignmentItem
                                  ?.IncludedSPSTradeLineItem
                                  ?.PhysicalSPSPackage &&
                                data?.api_data?.SPSConsignment
                                  ?.IncludedSPSConsignmentItem
                                  ?.IncludedSPSTradeLineItem?.PhysicalSPSPackage
                                  ?.ItemQuantity +
                                  " " +
                                  data?.api_data?.SPSConsignment
                                    ?.IncludedSPSConsignmentItem
                                    ?.IncludedSPSTradeLineItem
                                    ?.PhysicalSPSPackage?.TypeCode["@name"]
                                  ? data?.api_data?.SPSConsignment
                                      ?.IncludedSPSConsignmentItem
                                      ?.IncludedSPSTradeLineItem
                                      ?.PhysicalSPSPackage?.TypeCode["@name"]
                                  : data?.api_data?.SPSConsignment
                                      ?.IncludedSPSConsignmentItem
                                      ?.IncludedSPSTradeLineItem
                                      ?.PhysicalSPSPackage?.TypeCode} */}
                                {/* {(data?.api_data?.SPSConsignment
                                  ?.IncludedSPSConsignmentItem
                                  ?.IncludedSPSTradeLineItem
                                  ?.PhysicalSPSPackage &&
                                  data?.api_data?.SPSConsignment
                                    ?.IncludedSPSConsignmentItem
                                    ?.IncludedSPSTradeLineItem
                                    ?.PhysicalSPSPackage?.ItemQuantity) ||
                                  ""} */}
                                {!_.isEmpty(pro.physical_packages)
                                  ? pro.physical_packages[0].amount.replace(
                                      /\.000$/,
                                      ""
                                    )
                                  : ""}
                                {pro.physical_packages[0]?.unit
                                  ? " " + pro.physical_packages[0].unit
                                  : ""}
                                {_.isEmpty(pro.physical_packages)
                                  ? pro.sps_notes?.map((note, idx) => {
                                      if (note.note_type == 9) {
                                        return note.text;
                                      }
                                    })
                                  : ""}
                                {/* {data?.api_data?.SPSConsignment
                                  ?.IncludedSPSConsignmentItem
                                  ?.IncludedSPSTradeLineItem?.PhysicalSPSPackage
                                  ? typeof data?.api_data?.SPSConsignment
                                      ?.IncludedSPSConsignmentItem
                                      ?.IncludedSPSTradeLineItem
                                      ?.PhysicalSPSPackage?.ItemQuantity ==
                                    "object"
                                    ? data?.api_data?.SPSConsignment
                                        ?.IncludedSPSConsignmentItem
                                        ?.IncludedSPSTradeLineItem
                                        ?.PhysicalSPSPackage?.ItemQuantity[
                                        "#text"
                                      ] +
                                      " " +
                                      data?.api_data?.SPSConsignment
                                        ?.IncludedSPSConsignmentItem
                                        ?.IncludedSPSTradeLineItem
                                        ?.PhysicalSPSPackage?.ItemQuantity[
                                        "@unitCode"
                                      ]
                                    : data?.api_data?.SPSConsignment
                                        ?.IncludedSPSConsignmentItem
                                        ?.IncludedSPSTradeLineItem
                                        ?.PhysicalSPSPackage?.ItemQuantity
                                  : ""}
                                {data?.api_data?.SPSConsignment
                                  ?.IncludedSPSConsignmentItem
                                  ?.IncludedSPSTradeLineItem?.PhysicalSPSPackage
                                  ?.TypeCode["@name"]
                                  ? " " +
                                    data?.api_data?.SPSConsignment
                                      ?.IncludedSPSConsignmentItem
                                      ?.IncludedSPSTradeLineItem
                                      ?.PhysicalSPSPackage?.TypeCode["@name"]
                                  : typeof data?.api_data?.SPSConsignment
                                      ?.IncludedSPSConsignmentItem
                                      ?.IncludedSPSTradeLineItem
                                      ?.PhysicalSPSPackage?.TypeCode == "object"
                                  ? ""
                                  : data?.api_data?.SPSConsignment
                                      ?.IncludedSPSConsignmentItem
                                      ?.IncludedSPSTradeLineItem
                                      ?.PhysicalSPSPackage?.TypeCode
                                  ? " " +
                                    data?.api_data?.SPSConsignment
                                      ?.IncludedSPSConsignmentItem
                                      ?.IncludedSPSTradeLineItem
                                      ?.PhysicalSPSPackage?.TypeCode
                                  : ""} */}
                                {/* {!itemIsArray && packagingInfo}
                                {itemIsArray &&
                                  data?.api_data?.SPSConsignment
                                    ?.IncludedSPSConsignmentItem
                                    ?.IncludedSPSTradeLineItem[idx]
                                    ?.PhysicalSPSPackage?.ItemQuantity +
                                    " " +
                                    data?.api_data?.SPSConsignment
                                      ?.IncludedSPSConsignmentItem
                                      ?.IncludedSPSTradeLineItem[idx]
                                      ?.PhysicalSPSPackage?.TypeCode["@name"]}
                                {itemParentIsArray
                                  ? data?.api_data?.SPSConsignment
                                      ?.IncludedSPSConsignmentItem[idx]
                                      ?.IncludedSPSTradeLineItem
                                      ?.PhysicalSPSPackage
                                    ? typeof data?.api_data?.SPSConsignment
                                        ?.IncludedSPSConsignmentItem[idx]
                                        ?.IncludedSPSTradeLineItem
                                        ?.PhysicalSPSPackage?.ItemQuantity ==
                                      "object"
                                      ? data?.api_data?.SPSConsignment
                                          ?.IncludedSPSConsignmentItem[idx]
                                          ?.IncludedSPSTradeLineItem
                                          ?.PhysicalSPSPackage?.ItemQuantity[
                                          "#text"
                                        ] +
                                        " " +
                                        data?.api_data?.SPSConsignment
                                          ?.IncludedSPSConsignmentItem[idx]
                                          ?.IncludedSPSTradeLineItem
                                          ?.PhysicalSPSPackage?.ItemQuantity[
                                          "@unitCode"
                                        ]
                                      : ""
                                    : ""
                                  : ""} */}
                              </td>
                              <td>
                                {!_.isEmpty(pro.sps_notes)
                                  ? pro.sps_notes?.map((sps, idx) => {
                                      if (sps.note_type == 7) {
                                        return sps.text;
                                      }
                                    })
                                  : ""}
                              </td>
                              <td>
                                {
                                  countries?.filter(
                                    (c) => c.id == pro.manufactured_country
                                  )[0]?.name_en
                                }
                              </td>
                              <td>
                                {spsImpNum ? (
                                  <a
                                    href={`https://efito.uz/ikr/${spsImpNum}/download`}
                                    target="_blank"
                                  >
                                    {spsImpNum}
                                  </a>
                                ) : (
                                  ""
                                )}
                              </td>
                              <td>
                                {moment(data.given_date).format("DD-MM-YYYY")}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      ))}
                    </td>
                  </tr>
                  <tr>
                    <th colSpan={2}>Additional Declarations</th>
                  </tr>
                  <tr>
                    <td colSpan={2} style={{ whiteSpace: "wrap" }}>
                      {data.extra_info ? data.extra_info + "\n" : ""}
                      {/* {data?.sps_notes?.map((nt, idx) => {
                        if (nt.note_type == 1) {
                          if (nt.text != "NULL") {
                            return (
                              <p>
                                {nt.text}
                                <br />
                              </p>
                            );
                          }
                        }
                      })} */}
                      {/* {data?.sps_notes
                        ?.filter((nt) => {
                          console.log(nt.id);
                          return nt.note_type == 6;
                        })
                        ?.sort((a, b) => b.id - a.id)[0]?.text || ""} */}
                      {replacedCertContent ? replacedCertContent : ""}
                      {/* {adrpn ? <br /> : ""} */}
                      {replacedCertContent ? <br /> : ""}
                      {adrpn ? adrpnContent : ""}
                      {!adrpn && slicedAdrpn ? adrpnContent : ""}
                      {!_.isEmpty(adtlil)
                        ? adtlil.map((lil, idx) => {
                            return <div key={idx}>{lil}</div>;
                          })
                        : ""}
                    </td>
                  </tr>
                  <tr>
                    <th colSpan={2}>
                      Disinfestation and/or Disinfection Treatment
                    </th>
                  </tr>

                  <tr>
                    <td colSpan={2}>{treatment != "NULL" && treatment}</td>
                  </tr>

                  <tr>
                    <th
                      colSpan={2}
                      style={{ textAlign: "center", background: "#c4c7c7" }}
                      className="th-heading"
                    >
                      III. Certification
                    </th>
                  </tr>
                </tbody>
              </table>
              <table
                style={{
                  width: "auto",
                  marginLeft: "23px",
                  width: "calc(100% - 23px)",
                }}
              >
                <tbody>
                  {reexport && (
                    <tr>
                      <td colSpan={2} style={{ borderTop: "none" }}>
                        {reexport}
                      </td>
                    </tr>
                  )}
                  {spsClause && (
                    <tr>
                      <td colSpan={2} style={{ borderTop: "none" }}>
                        {spsClause}
                      </td>
                    </tr>
                  )}
                  {spsFinContent && (
                    <tr>
                      <td colSpan={2} style={{ borderTop: "none" }}>
                        {spsFinContent}
                      </td>
                    </tr>
                  )}
                  {description && (
                    <tr>
                      <td colSpan={2} style={{ borderTop: "none" }}>
                        {description}
                      </td>
                    </tr>
                  )}

                  <tr>
                    <td style={tableTwo}>
                      <strong>Place of issue:</strong>{" "}
                      {
                        data?.api_data?.SPSExchangedDocument
                          ?.SignatorySPSAuthentication?.IssueSPSLocation?.Name
                      }
                    </td>
                    <td style={tableTwo}>
                      <strong>Name of authorized officer: </strong>
                      {data.inspector_name || ""}
                    </td>
                  </tr>
                  <tr>
                    <td style={tableTwo}>
                      <strong>Date:</strong>{" "}
                      {
                        // data?.api_data?.SPSExchangedDocument?.IssueDateTime
                        //   ?.DateTimeString
                        noteTypeDate
                          ? noteTypeDate
                          : typeof data?.api_data?.SPSExchangedDocument
                              ?.IssueDateTime?.DateTimeString == "object"
                          ? data?.api_data?.SPSExchangedDocument?.IssueDateTime
                              ?.DateTimeString["#text"]
                          : data?.api_data?.SPSExchangedDocument?.IssueDateTime
                              ?.DateTimeString
                      }
                      {/* {moment(data.given_date).format("DD-MM-YYYY")} */}
                    </td>
                    <td style={tableTwo}>
                      <strong>Signature:</strong>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </>
  );
});

export default withRouter(ExportFss);
